import { routes } from "consts";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useToaster } from "utils";

import { HeaderWithBreadcrumbs, PageMain } from "components/molecules";
import { PlaceTagForm, PlaceTagFormValues } from "./PlaceTagForm/PlaceTagForm";
import { placeTagsApi } from "api/placeTagsApi";
import { usePlaceTag } from "api/hooks";

export const PlaceTagEditPage = (): JSX.Element | null => {
  const { placeTagId } = useParams();
  const { showSuccess, showError } = useToaster();
  const navigate = useNavigate();
  const { loading, data } = usePlaceTag(Number(placeTagId));

  if (loading || data === null) return null;

  const breadcrumbs = [
    { title: "Miejsca", path: routes.PLACES },
    { title: "Tagi", path: routes.PLACE_TAGS },
    { title: data.name },
  ];

  const onSubmit = async (data: PlaceTagFormValues) => {
    try {
      await placeTagsApi.update(Number(placeTagId), data);
      navigate(routes.PLACE_TAGS);
      showSuccess("Zaktualizowano tag");
    } catch (e) {
      showError("Nie udało się zaktualizować tagu");
      console.error(e);
    }
  };

  return (
    <PageMain>
      <HeaderWithBreadcrumbs breadcrumbs={breadcrumbs} headerText="Edytuj tag miejsca" />
      <PlaceTagForm onSubmit={onSubmit} data={data} />
    </PageMain>
  );
};
